export default {
  errors: {
    serverDown: "远程服务器已关闭",
    unknownError: "远程服务器上发生错误"
  }
}
